import { useState } from "react";
import { useSelector } from "react-redux";
import UserDialogManager from "../../dialogs/userDialogView/UserDialogManager";
import UserEnableDialog from "./UserEnableDialog";
import MultiUserEnable from "./MultiUserEnable";
import DisableUserTableHead from "./DisableUserTableHead";
import DisableUserList from "./DisableUserList";
import MultiUserEnableDialog from "./MultiUserEnableDialog";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";

function DisableUserContainer() {
  const usersData = useSelector((state) => state.data.data).users;
  const [userViewDetails, setUserViewDetails] = useState({});
  const [query, setQuery] = useState("");
  const [openEnableUserDialog, setOpenEnableUserDialog] = useState({});
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]); // store selected user IDs
  const [openMultiUserEnableDialog, setOpenMultiUserEnableDialog] =
    useState(false);

  const handleEnableDialog = (data) => {
    setOpenEnableUserDialog({ open: true, user: data });
  };

  // Filter users based on search query
  const filteredUsers = usersData?.filter((user) => {
    if (!query) return true; // show all if no search
    const lowerQuery = query.toLowerCase();

    return (
      user.id?.toString().includes(lowerQuery) ||
      user.fullName?.toLowerCase().includes(lowerQuery) ||
      user.email?.toLowerCase().includes(lowerQuery)
    );
  });

  // Handle single user select toggle
  const handleUserSelect = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  // Select or deselect all
  const handleSelectAllUsers = () => {
    if (selectedUsers.length === usersData.length) {
      setSelectedUsers([]); // unselect all
    } else {
      setSelectedUsers(usersData.map((user) => user.id)); // select all
    }
  };

  // Cancel selection mode
  const handleCancelSelection = () => {
    setIsSelectionMode(false);
    setSelectedUsers([]);
  };

  const handleEnableUsers = () => {
    if (selectedUsers.length === 0) return;
    setOpenMultiUserEnableDialog(true);
  };

  // Check if all selected
  const allSelected =
    selectedUsers.length > 0 && selectedUsers.length === usersData.length;

  return (
    <div className="flex gap-4 max-lg:gap-2 my-3 h-[calc(100vh-5em)] max-lg:h-[calc(100vh-4em)] max-md:h-[calc(100vh-5em)] flex-col">
      {usersData.length !== 0 && (
        <div className="flex items-center justify-between">
          <input
            type="text"
            placeholder="Search by ID, Name, Email..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="border rounded-lg px-3 py-2 w-full focus-input"
          />
          <MultiUserEnable
            isSelectionMode={isSelectionMode}
            setIsSelectionMode={setIsSelectionMode}
            selectedCount={selectedUsers.length}
            onDisable={handleEnableUsers}
            onCancel={handleCancelSelection}
          />
        </div>
      )}
      <div className="bg-white p-4 rounded-lg h-full relative">
        <div className="max-h-[735px] max-lg:h-[590px] max-md:h-[580px] overflow-scroll">
          <table className="w-full border-collapse text-center">
            <DisableUserTableHead
              isSelectionMode={isSelectionMode}
              allSelected={allSelected}
              handleSelectAllUsers={handleSelectAllUsers}
            />
            {filteredUsers.length !== 0 ? (
            <DisableUserList
              filteredUsers={filteredUsers}
              selectedUsers={selectedUsers}
              isSelectionMode={isSelectionMode}
              handleUserSelect={handleUserSelect}
              setUserViewDetails={setUserViewDetails}
              handleEnableDialog={handleEnableDialog}
            />
               ) : (
               <NoDataDisplay />
            )}
          </table>
        </div>
      </div>
      {Object.entries(userViewDetails).length !== 0 && (
        <UserDialogManager
          closeDialog={() => setUserViewDetails({})}
          userData={userViewDetails}
        />
      )}
      {openEnableUserDialog?.open && (
        <UserEnableDialog
          userData={openEnableUserDialog.user}
          closeDialog={() => setOpenEnableUserDialog({})}
        />
      )}
      {openMultiUserEnableDialog && (
        <MultiUserEnableDialog
          closeDialog={() => setOpenMultiUserEnableDialog(false)}
          userIDs={selectedUsers}
          selectedCount={selectedUsers.length}
        />
      )}
    </div>
  );
}

export default DisableUserContainer;
